import { DropdownPlugin } from 'bootstrap-vue';
import moment from 'moment';
import Vue from 'vue';
import { FunctionalCalendar } from 'vue-functional-calendar';
import VueRouter from 'vue-router';
import VueTheMask from 'vue-the-mask';
import Vuelidate from 'vuelidate';
import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
import dateFilterEl from './modules/accommodatie/date-filter.vue';
import store from './store';

Vue.use(FunctionalCalendar);
Vue.use(DropdownPlugin);
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(require('vue-moment'));
Vue.use(VueTheMask);
Vue.use(Vuelidate);

Vue.use(vuexI18n.plugin, store, {
    moduleName: 'i18n',
    onTranslationNotFound(locale, key) {
        if (store.state.langKeysSearching[key]) {
            return `!${key}!`;
        }
        store.state.langKeysSearching[key] = true;
        // console.warn(`i18n :: Key '${key}' not found for locale '${locale}'`);
        return new Promise((resolve, reject) => {
            store
                .dispatch('setTranslationForKey', {
                    locale: locale,
                    key: key
                })
                .then(() => {
                    if (store.state.i18n.translations[locale][key] === undefined) {
                        resolve(`!${key}!`);
                        store.state.langKeysSearching[key] = false;
                    } else {
                        resolve(store.state.i18n.translations[locale][key]);
                        store.state.langKeysSearching[key] = false;
                    }
                })
                .catch(e => {
                    reject(e);
                });
        });
    }
});

export const serverBus = new Vue();

const router = new VueRouter({
    mode: 'history'
});

Vue.component('v-style', {
    render: function(createElement) {
        return createElement('style', this.$slots.default);
    }
});

Vue.filter('toCurrency', function(value) {
    if (typeof value !== 'number') {
        return value;
    }

    const lang = JSON.parse(localStorage.getItem('language'));
    const formatter = new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });

    var currencyVal = formatter.format(value);
    return currencyVal.replace('€ ', '');
});

function init() {
    const header = document.querySelector('header.header');
    let beperktBoekenMoment;
    if (header) {
        const beperktBoekenTotRaw = header.getAttribute('data-beperkt-boeken-tot-datum');
        beperktBoekenMoment = moment(beperktBoekenTotRaw).toDate();
    }

    const herofilter = document.getElementById('herofilter');

    if (herofilter !== null && herofilter !== undefined) {
        let objectFilter = herofilter.getAttribute('data-object-filter') === 'true';
        let googleAnalytics = herofilter.getAttribute('data-googleAnalytics');

        new Vue({
            el: '#herofilter',
            router,
            store,
            render: h =>
                h(dateFilterEl, {
                    props: {
                        id: 1,
                        objectFilter: objectFilter,
                        beperktBoekenTot: beperktBoekenMoment,
                        googleAnalytics: googleAnalytics,
                        dropup: true
                    }
                })
        });
    }
}

export default {
    init
};
